import { render, staticRenderFns } from "./DonutChart2.vue?vue&type=template&id=586feee0&scoped=true"
import script from "./DonutChart2.vue?vue&type=script&lang=js"
export * from "./DonutChart2.vue?vue&type=script&lang=js"
import style0 from "./DonutChart2.vue?vue&type=style&index=0&id=586feee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586feee0",
  null
  
)

export default component.exports